import DocumentImporterConfiguration from "../payslips/services/model/DocumentImporterConfiguration";
import {
  SupportedDocumentAttributes,
  SupportedFeatures,
} from "../payslips/services/model/FeatureConfiguration";

export const irp5JourneyConfiguration: DocumentImporterConfiguration = {
  document_type: SupportedFeatures.IRP5s,
  document_name: "IRP5",
  document_name_lower_case: "IRP5",
  document_name_plural: "IRP5s",
  document_name_plural_lower_case: "IRP5s",
  main_page_route: "",
  attributes: [
    SupportedDocumentAttributes.BATCH_NAME,
    SupportedDocumentAttributes.ISSUE_DATE,
    SupportedDocumentAttributes.DISTRIBUTION_DATES,
  ],
};
